import { styled } from '@stitches/configed';
import { TooltipProps } from 'recharts';
import {
  ValueType,
  NameType,
} from 'recharts/types/component/DefaultTooltipContent';

const CustomTooltipChart = <TValue extends ValueType, TName extends NameType>({
  active,
  payload,
  label,
}: TooltipProps<TValue, TName>) => {
  if (active && payload && payload.length) {
    return (
      <TooltipWrapStyled>
        <div>{label}</div>
        <div
          style={{
            fontWeight: 700,
          }}
        >
          {payload[0].value} {payload[0].unit}
        </div>
      </TooltipWrapStyled>
    );
  }

  return null;
};

const TooltipWrapStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 12,
  gap: 4,
  background: '$content-primary',
  borderRadius: 8,
  color: 'white',
});
export default CustomTooltipChart;
